/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, Flex, Radio } from '@tonic-one/react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import {
  useExchangeInlineTargetDomains,
  useExchangeInlineTargetUserGroups,
} from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { TargetType } from 'src/utils/enums';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import { PolicySubTypeEnum } from '@Types/index';

export const TargetUserGroupsInline = () => {
  const props = useExchangeInlineTargetUserGroups();
  return <TargetUserGroups {...props} />;
};
export const TargetDomain = () => {
  const props = useExchangeInlineTargetDomains();
  return <TargetUserGroups {...props} />;
};

const General = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  const [targetType, setTargetType] = React.useState<TargetType>();
  const policyTarget = policySelector((s) => s.policyTarget);
  const policySubType = policySelector((state) => state.policySubType);
  const setTempVars = contextSelector((s) => s.setTempVars);
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const mipAndTokenFeatureShow =
    !!selectedOrgGlobalSetting?.mipAndTokenFeatureShow;
  const handleTargetTypeChange = React.useCallback((type: TargetType) => {
    console.log('handleTargetTypeChange', type);
    setTargetType(type);
    setTempVars({
      targetType: type,
    });
  }, []);

  useEffect(() => {
    if (policyTarget.targetType === TargetType.UserAndGroup) {
      setTempVars({
        targetType: TargetType.UserAndGroup,
        targetUserGroups: {
          ...policyTarget,
        },
      });
      setTargetType(TargetType.UserAndGroup);
    } else if (policyTarget.targetType === TargetType.Domain) {
      setTempVars({
        targetType: TargetType.Domain,
        targetDomains: {
          ...policyTarget,
        },
      });
      setTargetType(TargetType.Domain);
    }
  }, []);
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={
          policySubType === PolicySubTypeEnum.outbound && mipAndTokenFeatureShow
            ? true
            : false
        }
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <Radio
          value={TargetType.Domain}
          checked={targetType === TargetType.Domain}
          onClick={() => {
            handleTargetTypeChange(TargetType.Domain);
          }}
        >
          <FormLabel label={t('policy.label.policyTargetDomain')} width={300} />
        </Radio>
      </Flex>
      {targetType === TargetType.Domain ? (
        <Flex mt="8px" alignItems="flex-start">
          <TargetDomain />
        </Flex>
      ) : null}
      <Flex mt="8px" alignItems="flex-start">
        <Radio
          value={TargetType.UserAndGroup}
          checked={targetType === TargetType.UserAndGroup}
          onClick={() => {
            handleTargetTypeChange(TargetType.UserAndGroup);
          }}
        >
          <FormLabel
            label={t('policy.label.policyTargetUserGroup')}
            width={300}
          />
        </Radio>
      </Flex>
      {targetType === TargetType.UserAndGroup ? (
        <Flex mt="8px" alignItems="flex-start">
          <TargetUserGroupsInline />
        </Flex>
      ) : null}
    </Box>
  );
};
export default React.memo(General);
